<template>
  <div class="row justify-content-center">
    <div :class="[width ? '' : 'col-6 col-lg-5 col-xl-4']" :style="{width}">
      <div class="jumbotron pt-4 mt-5">

        <div class="mb-4 text-center">
          <img class="img-fluid" src="@/assets/images/control-center.png" alt="Thrive Control Center">
        </div>

        <slot></slot>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jumbotron',
  props: {
    width: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
